import { render, staticRenderFns } from "./AddChildUser.vue?vue&type=template&id=20b01a84&scoped=true"
import script from "./AddChildUser.vue?vue&type=script&lang=js"
export * from "./AddChildUser.vue?vue&type=script&lang=js"
import style0 from "./AddChildUser.vue?vue&type=style&index=0&id=20b01a84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b01a84",
  null
  
)

export default component.exports